<template>
  <app-modal v-model="isDialogOpened"
             size="xs"
             :ok-text="$t('common.delete')"
             :ok-loading="deleteSavedChecklistPending"
             :ok-disabled="deleteSavedChecklistPending"
             :cancel-disabled="deleteSavedChecklistPending"
             @ok="prepareDeleteSavedChecklist"
             @cancel="closeDialog"
  >
    <template #title>{{ $t('project.checklist.dialogs.SavedChecklistDeleteDialog.title') }}</template>
    <template #body>{{ $t('project.checklist.dialogs.SavedChecklistDeleteDialog.text') }}</template>
  </app-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import { toast } from '@/common/utils/toast'
import { dialogMixin } from '@/mixins/dialogMixin'
import { DELETE_SAVED_CHECKLIST } from '@/store/modules/checklist/action_types'

export default {
  name: 'SavedChecklistDeleteDialog',
  mixins: [dialogMixin],
  props: {
    checklistId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapState('checklist', ['savedChecklists', 'deleteSavedChecklistPending']),
  },
  methods: {
    ...mapActions('checklist', [DELETE_SAVED_CHECKLIST]),
    async prepareDeleteSavedChecklist () {
      try {
        await this.DELETE_SAVED_CHECKLIST({
          todoListId: this.checklistId,
        })
        const index = this.savedChecklists.findIndex(item => item.id === this.checklistId)
        if (index !== -1) {
          this.savedChecklists.splice(index, 1)
          toast.success(this.$t('project.checklist.dialogs.SavedChecklistDeleteDialog.deleteSavedChecklistSuccess'))
        }
      } catch (e) {
        toast.error(this.$t('project.checklist.dialogs.SavedChecklistDeleteDialog.deleteSavedChecklistError'))
      } finally {
        this.closeDialog()
      }
    },
  },
}
</script>
